module.exports = __webpack_public_path__ + "static/media/delete.34cba236.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/delete.svg
// module id = 1313
// module chunks = 29